export enum SERVER_CODE {
  SUCCESS = 10000,
}
